<div class="plataforma-badge">
    <img [src]="logoURL" [attr.alt]="nome" [attr.title]="nome" [ngStyle]="{width: logoURLWidth}">
    <span *ngIf="isShowNome">{{nome}}</span>
</div>  